<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form
      ref="edit_part_dealer_form"
      @submit.prevent="handleSubmit(updatePartDealer)"
    >
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
            Edit Vehicle Brand
          </h4>
        </md-card-header>
        <md-card-content>
          <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Vehicle No.(Read)<span style="color:red">*</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="no" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-input v-model="vehicle_no" readonly/>
              <validation-error :errors="apiValidationErrors.vehicle_no" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div> -->
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Vehicle Brand Name</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider rules="brand" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input v-model="vehicle_brand.vehicle_brand_name" />
                  <validation-error
                    :errors="apiValidationErrors.vehicle_brand_name"
                  />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button @click="editConfirmation">
            Edit Brand Name
          </md-button>
          <md-button class="md-info" @click="backtoList">
            Go to List
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend, validate, localize, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";

Vue.use(VueSweetalert2);

extend("brand", {
  ...required,
  message: "Vehicle Brand Name field is required",
});
extend("no", {
  ...required,
  message: "Vehicle No. field is required",
});
export default {
  name: "edit-vehicle",

  components: { ValidationError, ValidationObserver },
  mixins: [formMixin],

  data: () => ({
    // vehicle_no: null,
    vehicle_brand: null,
  }),

  created() {
    this.getVehicleData();
  },

  methods: {
    // fungsi tombol direct ke list vehicle
    backtoList() {
      this.$router.replace({ name: "List Vehicle Type" });
    },

    // ambil data yang diperlukan
    async getVehicleData() {
      // check data dengan id di route
      if (this.$route.params.id) {
        console.log(this.$route.params.id);
        
        await this.$store.dispatch("workshop_vehicle_brand/get", this.$route.params.id);
        this.vehicle_brand = await this.$store.getters["workshop_vehicle_brand/vehicle_brand"];
        // this.vehicle_no = this.vehicle_brand.vehicle_no;
       // this.vehicle_brand_name = this.vehicle_brand.vehicle_brand_name;
        console.log(this.vehicle_brand);
      }
    },

    // validasi edit data
    editConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be edited!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Edit it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.updateVehicle(id);
        }
      });
    },

    // fungsi edit data
    async updateVehicle() {
      if (this.$route.params.id == null || !this.$route.params.id) {
        await this.$store.dispatch(
          "alerts/error",
          "You are not allowed not change data of default users."
        );
        return;
      }

      const data = {
        type: "workshop_vehicle_brands",
        id: this.vehicle_brand.id,
        // vehicle_no: this.vehicle_no,
        vehicle_brand_name: this.vehicle_brand.vehicle_brand_name,
      };

      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_vehicle_brand/update", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle Brand data changed successfully."
        );
        // kembali ke list vehicle
        this.backtoList()
        //this.$refs['password_form'].reset()
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
